import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type StateService from 'garaje/services/state';

import type CommunicationsMessageLogNewController from './controller';

export default class CommunicationsMessageLogNewRoute extends Route {
  @service declare state: StateService;

  async model(): Promise<void> {
    // Preload emergency notification configuration
    await this.state.currentLocation.getEmergencyNotificationConfiguration();
  }

  // Ember treats declared queryParams as sticky by default — leaving the route
  // preserves them on the controller, and re-entering (via "+ New incident" nav,
  // sidebar links, etc.) restores the last values into the URL bar. That resurrected
  // the previous deep-link's `?threat=` + `?source=`, and since RRC's SendMessage
  // reads window.location.search on mount, the form pre-populated from a stale
  // threat. Reset the params on exit so a fresh composer is always blank unless the
  // current navigation explicitly carries new params.
  resetController(controller: CommunicationsMessageLogNewController, isExiting: boolean): void {
    if (isExiting) {
      controller.from = '';
      controller.threat = '';
      controller.source = '';
    }
  }
}
